/**
 * Calculate profile completion percentage based on filled fields
 * Based on the logic from kandor-frontend profileCompleteness.js
 */
export const calculateProfileCompleteness = data => {
	if (!data) return 0

	const {
		// personal
		name,
		email,
		phone,
		nationality,
		country,
		city,
		dateOfBirth,
		schoolName,

		// academics
		educationLevel,
		schoolClass,
		grades,
		academicTranscripts,
		academicAchievements,

		// tests
		sat,
		act,
		gre,
		gmat,
		otherTestScore,
		skipScores,

		// extracurricular
		activities,
		skipActivities,

		// work
		skipUpload,
		resumeFiles,
		experiences,
		skipExperience,

		// subject interests
		intendedMajor,
		careerAspirations,
		researchInterests,
		whyAbroad,

		// language
		proficiencyLevel,
		englishTestType,
		englishTestScore,
		skipEnglish,
		languageCertificates,
		languagesSpoken,
	} = data

	const sections = [
		{
			id: 'personal',
			completed: !!(
				name ||
				email ||
				phone ||
				nationality ||
				country ||
				city ||
				dateOfBirth ||
				schoolName
			),
		},
		{
			id: 'academics',
			completed: !!(
				educationLevel ||
				schoolClass ||
				grades ||
				(academicTranscripts && academicTranscripts.length) ||
				academicAchievements
			),
		},
		{
			id: 'scores',
			skip: !!skipScores,
			completed: !!(sat || act || gre || gmat || otherTestScore),
		},
		{
			id: 'activities',
			skip: !!skipActivities,
			completed: !!(activities && activities.length),
		},
		{
			id: 'work',
			skip: !!skipExperience,
			completed: !!(
				skipUpload ||
				(resumeFiles && resumeFiles.length) ||
				(experiences && experiences.length)
			),
		},
		{
			id: 'subject_interests',
			completed: !!(
				intendedMajor ||
				careerAspirations ||
				researchInterests ||
				whyAbroad
			),
		},
		{
			id: 'language',
			skip: !!skipEnglish,
			completed: !!(
				proficiencyLevel ||
				englishTestType ||
				englishTestScore ||
				(languageCertificates && languageCertificates.length) ||
				languagesSpoken
			),
		},
	]

	const considered = sections.filter(s => !s.skip)
	if (!considered.length) return 0

	const completed = considered.filter(s => s.completed).length

	return Math.round((completed / considered.length) * 100)
}
